<template>
  <div
    id="hspotscont"
    class="hspost-container hspotscont"
    :class="[
      { hspotscont_minimized: l_minimized },
      { hspotscont_minimized_open: l_innerMaximized },
      { hspotscont_reversed: openToTop },
      { hspotscont_vertical: l_isVertical },
    ]"
    @click="handleClick"
  >
    <slot
      name="before"
      :minimized="contentMinimized"
      :maximized="l_innerMaximized"
    />
    <div
      class="hspotscont_inner_container"
      tour="historyevents"
    >
      <HorizolnalScroller
        ref="HorizolnalScroller"
        :watchActionId="scrollerWatchActionId"
        :isVertical="l_isVertical"
        class="hspotscont_inner"
        :style="{
          '--hscroller-radius': '4px',
          '--clr-arrow-back': 'var(--clr-hs-back)',
          '--arrow-height': 'var(--hs-arrow-height)',
          '--hscroller-align-items': `${openToTop ? 'flex-end' : 'flex-start'}`,
          '--arrow-inset': `${openToTop ? 'auto auto 0 auto' : '0 auto auto auto'}`,
        }"
        :class="{ hspotscont_inner_maximized: l_innerMaximized }"
        :innerCssClass="`
                ${
                  l_isVertical
                    ? 'hspotscont_inner_vertical_scrollable'
                    : 'hspotscont_inner_scrollable'
                }
                ${innerCssClass || ''}`"
        :innerId="`${namespace ? `${namespace}/` : ''}hspotscont_inner`"
        @close:vertical="minimize"
      >
        <slot
          name="content"
          :minimized="contentMinimized"
        />
      </HorizolnalScroller>
    </div>
    <div
      v-show="l_innerMaximized"
      class="hspotscont_close_container"
      @click.stop="minimize"
    >
      <div
        v-show="l_innerMaximized"
        class="hspotscont_close"
        @click="minimize"
      >
        <i class="mdi mdi-chevron-down icon_btn hspotscont_close_icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
import HorizolnalScroller from '@/components/HorizolnalScroller/HorizolnalScroller'

export default {
  name: 'HspotsContainer',
  components: {
    HorizolnalScroller,
  },
  props: {
    namespace: { String, required: true },
    innerCssClass: String,
    minimized: { type: Boolean, default: true },
    openToTop: Boolean,
    hasMinimized: { type: Boolean, default: true },
    isMinimizedVertical: Boolean,
    scrollerWatchActionId: { default: () => 'horizontal_scroll_check' },
  },
  beforeUnmount() {
    this.removeListeners()
  },
  methods: {
    setListeners() {
      window.addEventListener('mousedown', this.handleMousedown)
    },
    removeListeners() {
      window.removeEventListener('mousedown', this.handleMousedown)
    },
    handleClick(e) {
      // active card maximizes, inactive sets spot, action click maximizes
      if (e.gw_eventCardHandler === 'inactiveCardClick') return
      if (this.minimized) return

      if (this.l_minimized && !this.l_innerMaximized) {
        this.$store.dispatch('globals_hs_open')
        this.setListeners()
      }
    },
    minimize() {
      if (this.l_innerMaximized) {
        this.$store.dispatch('globals_hs_open')
        this.removeListeners()
      }
    },
    handleMousedown(e) {
      const shouldMinimize = !this.cursorInside(e.target)
      // console.log('shouldMinimize hSpots', shouldMinimize)
      if (shouldMinimize) {
        this.minimize()
      }
    },
    cursorInside(el) {
      if (
        [
          'dialogoverlay', //
          'hspotscont',
          'cardsdialog',
          'shortcutdialog',
          'selectboardbtn',
        ].includes(el.id)
      ) {
        return true
      }
      if (!el.parentElement) {
        return false
      }
      return this.cursorInside(el.parentElement)
    },
  },
  computed: {
    l_isVertical() {
      return this.isMinimizedVertical && !this.contentMinimized
    },
    l_minimized() {
      return this.hasMinimized ? (this.minimized ? true : this.globals_fullscreen) : false
    },
    l_innerMaximized() {
      return this.globals_hs_open && !this.minimized && this.globals_fullscreen
    },
    contentMinimized() {
      return this.l_minimized && !this.l_innerMaximized
    },
    globals_fullscreen() {
      return this.$store.getters.globals_fullscreen
    },
    globals_hs_open() {
      return this.$store.getters.globals_hs_open
    },
  },
}
</script>

<style lang="scss">
.hspotscont_inner_scrollable {
  display: flex;
  gap: var(--hs-grid-gap);
  align-items: flex-end;
}
.hspotscont_inner_vertical_scrollable {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  gap: var(--hs-grid-gap);
  position: relative;
}
</style>

<style lang="scss" scoped>
.hspotscont {
  position: relative;
  display: flex;
  z-index: var(--z-index-history-events);

  --height-hspot-card-max: 8.75em;
  --height-min: 2.25em;
  // --height-max: 9.75em;
  --height-max: 9.25em;
  --padding: 0;
  padding: var(--padding);

  --clr-hs-back: var(--glo-hs-back);

  --hs-spot-clr-border: var(--clr-black-1);

  --hs-grid-gap: 4px;
  --hs-align-items: flex-start;

  --height: var(--height-hspot-card-max);
  --hs-arrow-height: var(--height);

  min-width: 0;
  min-height: 0;
  height: var(--height);
  width: 100%;
  gap: var(--hs-grid-gap);

  flex-shrink: 0;

  &::before {
    content: '';
    position: absolute;
    border-radius: 4px;
    inset: 0 0 auto auto;
    width: 100%;
    height: 100%;
  }
  // --clr-open-back: var(--clr-black-2);
  // --clr-open-back: var(--clr-black-1-3);
  // --clr-open-back: var(--clr-black-0-1);
  // --clr-open-back: var(--clr-black-0-2);
  // --clr-open-back: var(--clr-black-0-3);
  --clr-open-back: var(--clr-black-0);

  &_minimized {
    --height: var(--height-min);
    &_open {
      --clr-hs-back: var(--clr-open-back);
      --padding: 0 0 0.5rem 0;
      --width: calc(100vw - var(--laytsttd-padding) * 2);
      width: var(--width);
      &::before {
        height: var(--height-max);
        box-shadow: 0px 0px 0.5rem 0.125rem black;
        background: var(--clr-hs-back);
      }
      .hspotscont_close_container {
        position: absolute;
        inset: calc(var(--height-max) - 1px - 0.75rem) auto auto 50%;
        --inset-reversed: auto auto calc(1 * var(--height-max) - 1px - 0.75rem) 50%;
        transform: translate(-50%, 0) rotate(180deg);
        height: 4rem;
        width: 6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 1;
        overflow: hidden;
        --tab-radius: 12px;
        .hspotscont_close {
          background: var(--clr-hs-back);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          height: 2.5rem;
          width: 5rem;
          border-radius: var(--tab-radius) var(--tab-radius) 0 0;
          &_icon {
            font-size: 2rem;
          }
          &:before {
            content: '';
            position: absolute;
            bottom: 0;
            left: calc(var(--tab-radius) * -1);
            height: 100%;
            width: var(--tab-radius);
            border-bottom-right-radius: var(--tab-radius);
            box-shadow: 0 20px 0 0 var(--clr-hs-back);
          }
          &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 100%;
            height: 100%;
            width: var(--tab-radius);
            border-bottom-left-radius: var(--tab-radius);
            box-shadow: 0 20px 0 0 var(--clr-hs-back);
          }
        }
      }
    }
  }
  &_vertical {
    --height-max: 100vh;
    --clr-open-back: var(--clr-black-0);
    .hspotscont_minimized_open {
      --width: 100vw;
    }
  }

  &_reversed {
    --hs-align-items: flex-end;
    &.hspotscont_minimized_open {
      &:before {
        inset: auto auto 0 0;
      }
    }
    .hspotscont_close_container {
      transform: translate(-50%, 0);
      inset: var(--inset-reversed);
    }
  }
  &_inner_container {
    flex: 1;
    align-items: var(--hs-align-items);
    min-height: 0;
    min-width: 0;
    display: flex;
  }
  &_inner {
    display: flex;
    border-radius: 4px;
    z-index: 2;
    min-height: 0;
    min-width: 0;
    &_maximized {
      --height: var(--height-max);
      --hs-arrow-height: var(--height-hspot-card-max);
    }
  }
}

@media (max-width: 1023px) {
  .hspotscont {
    &_minimized_open {
      display: flex;
      .hspotscont_close {
        display: none;
      }
    }
    &_inner {
      &_maximized {
        &::before {
          top: 0.125rem;
        }
      }
    }
  }
}

@media screen and (orientation: portrait) {
  @media (max-width: 1023px) {
    .hspotscont {
      &_minimized_open {
        flex-direction: column;
      }
    }
  }
}
</style>
